const getMainScrollingElement = () => document.getElementById('MainScrollElement')
const lockMainScrolling = () => document.body.classList.add('scrollLock')
const unlockMainScrolling = () => document.body.classList.remove('scrollLock')

export { getMainScrollingElement, lockMainScrolling, unlockMainScrolling }
